"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Jun 29 2018
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * PromotionTypeConverter.
 *
 * @author ZSr
 */


var PromotionTypeConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(PromotionTypeConverter, _DataObjectConverter_);

  function PromotionTypeConverter() {
    _classCallCheck(this, PromotionTypeConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(PromotionTypeConverter).apply(this, arguments));
  }

  return PromotionTypeConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.PromotionTypeConverter = PromotionTypeConverter;